import React from "react";

const ShippingPolicy = () => (
  <div className="min-h-screen pt-28 sm:pt-32 bg-gray-900 text-white px-4 sm:px-6 lg:px-8 py-8 max-w-4xl mx-auto">

    <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-8 text-teal-400 border-b border-teal-600 pb-4 break-words">
      Shipping Policy
    </h1>

    <p>
      At <strong>MEHAR TRADERS INTERNATIONAL LTD</strong>, our goal is to deliver your products safely and on time.
      Please read our shipping policy below.
    </p>

    {/* Shipping Locations */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">1. Shipping Locations</h2>
    <p>
      We currently deliver to all areas within the United Kingdom only.  
      <br />International shipping is <strong>not available</strong> at this time.
    </p>

    <h3 className="text-lg sm:text-xl font-semibold mt-4 mb-2">International Orders (Customer-Arranged)</h3>
    <p>
      International customers may arrange their own freight forwarder or courier to collect goods from our warehouse.
      Orders must be fully paid before collection.  
      We can provide commercial invoices and packing lists upon request.  
      <strong>We do not take responsibility</strong> for customs delays, damages, or issues once goods leave our warehouse.
    </p>

    {/* Order Processing */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">2. Order Processing Times</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Orders are processed within 1–3 business days (Monday–Friday).</li>
      <li>Orders placed after 2 PM may be processed the next working day.</li>
      <li>Bulk orders may require additional time depending on stock availability.</li>
    </ul>

    {/* Shipping Methods */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">3. Shipping Methods & Delivery Times</h2>

    <p className="mt-2 mb-1 font-semibold">• Orders under 8 cases:</p>
    <p>Tracked Next Day Delivery</p>

    <p className="mt-4 mb-1 font-semibold">• Orders over 8 cases:</p>
    <p>Delivered via freight carriers depending on your delivery zone.</p>

    <p className="mt-6">Delivery times may vary depending on region and courier availability.</p>

    {/* Shipping Charges */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">4. Shipping Charges</h2>
    <p>
      Shipping costs are based on order size, weight, and delivery location.
      Final delivery charges will appear at checkout or be quoted separately.
      Free shipping may apply on qualifying bulk orders or promotions.
    </p>

    {/* Tracking */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">5. Order Tracking & Notifications</h2>
    <ul className="list-disc list-inside">
      <li>Tracking details are emailed once the order has been dispatched.</li>
      <li>Please ensure your delivery address is accurate.</li>
      <li>Re-delivery fees may apply if delivery fails due to an incorrect address or missed delivery.</li>
    </ul>

    {/* Delivery Issues */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">6. Delivery Issues</h2>
    <p>
      Please inspect your delivery immediately upon arrival.
      Any damages, shortages, or issues must be reported within <strong>48 hours</strong>.
    </p>
    <p className="mt-4">
      If an order is returned to us due to unsuccessful delivery or non-collection, a handling fee of
      <strong> £10 + VAT </strong> may apply.
    </p>

    {/* Contact */}
    <h2 className="text-xl sm:text-2xl font-semibold mt-8 mb-2">7. Shipping Contact</h2>
    <p>
      <strong>MEHAR TRADERS INTERNATIONAL LTD</strong><br />
      63 Orchard Grove, Harrow, United Kingdom, HA3 9QR<br /><br />

      <strong>Return Address:</strong><br />
      100 Randall Avenue, London, United Kingdom, NW2 7SU<br /><br />

      Email: info@mehartraders.co.uk, hello@mehartradersinternational.co.uk<br />
      Phone: +44 7448 739174
    </p>

    <p className="mt-8">
      By placing an order with <strong>MEHAR TRADERS INTERNATIONAL LTD</strong>,
      you agree to the terms of this Shipping Policy.
    </p>

  </div>
);

export default ShippingPolicy;
